export default "__VITE_ASSET__Dt318CDc__"